import Text from '@zenbusiness/zui/Text';

import { FootnoteAnchorLink } from '../components/FootnotesSection/FootnoteAnchorLink';

export const messageFormatValues = {
  b: (chunks) => <Text component="span" weight="medium">{chunks}</Text>,
  br: <br />,
  p: (chunks) => <Text component="p" sx={{ margin: 0 }}>{chunks}</Text>,
  footnoteAnchorLink: (chunks) => <FootnoteAnchorLink chunks={chunks} />,
  ul: (chunks) => <ul style={{ paddingLeft: 4, listStyleType: 'disc' }}>{chunks}</ul>,
  li: (chunks) => <li style={{ margin: 0 }}>{chunks}</li>
};
